import hydrachain from "../../../static/assets/images/partners/hydra-logo.webp";
import locktrip from "../../../static/assets/images/partners/locktrip_logo.svg";
import bitcoingold from "../../../static/assets/images/partners/logo-btg-1.png";
import unifarm from "../../../static/assets/images/partners/unifrarm-logo.svg";
import stakingrewards from "../../../static/assets/images/partners/stakingrewards.svg";

export const logosParners = [
    {
        href: 'https://hydrachain.org/',
        src: hydrachain,
        name: 'hydrachain',
        id: 'hydrachain'
    },
    {
        href: 'https://locktrip.com/',
        src: locktrip,
        name: 'locktrip',
        id: 'locktrip'
    },
    {
        href: 'https://bitcoingold.org/',
        src: bitcoingold,
        name: 'bitcoingold',
        id: 'bitcoingold'
    },
    {
        href: 'https://unifarm.co/',
        src: unifarm,
        name: 'unifarm',
        id: 'unifarm'
    },
    {
        href: 'https://www.stakingrewards.com/',
        src: stakingrewards,
        name: 'stakingrewards',
        id: 'stakingrewards'
    }
]

export const heroPartnerObj = {
    titleObj: {
        h1: "Become a Partner",
        h2: "Set Your Cryptocurrency For Success With Changex!",
        h3: "Streamline the entire process of staking your token inside an intuitive, non-custodial DeFi wallet, and expand your user base with our DeFi-savvy community.",
        h4: ""
    },
    text: "",
    appBtnsVisible: false,
    scrollBtnText: "",
    backgroundImage: '',
    quoteObject: {
        author: '',
        quote: '',
        role: '',
        img: ''
    },
    class: 'partnerPage',

    perks: {
        perksTitle: "Benefits Of Integrating",
        perksBtns: [
            {
                text: "For Your Business",
                id: "for_your_business"
            },
            {
                text: "For Your Customers",
                id: "for_your_customers"
            }
        ],
        perks0: [
            {
                src: '/assets/images/partners/icn-staking-noncustodial.svg',
                title: 'Staking in a Non-custodial DeFi Wallet',
                text: 'Staking has never been so easy: enable your users to stake their tokens from their mobile devices in a few clicks.\n'
            },
            {
                src: '/assets/images/partners/icn-marketingsupport.svg',
                title: 'Marketing Support',
                text: 'Changex will promote your token to a savvy-defi community through our social media channels.'
            },
            {
                src: '/assets/images/partners/icn-listingtop.svg',
                title: 'Listing In Top 20',
                text: 'Get maximum attention for your token by placing it among the top 20 in our rankings on the “Buy” & “Stake” screens.'
            }
        ],
        perks1: [
            {
                src: '/assets/images/partners/icn-zerocommision.svg',
                title: 'Zero commissions',
                text: 'Instead of charging a commission, Changex uses 5% of users’ staking rewards to purchase CHANGE and reward them accordingly.'
            },
            {
                src: '/assets/images/partners/icn-debitcard.svg',
                title: 'Crypto Debit Card',
                text: 'Changex’s Crypto Debit Card will enable users to seamlessly spend all in-app tokens - your token will be fully usable in the real world. Anywhere.'
            },
            {
                src: '/assets/images/partners/icn-leveragedstaking.svg',
                title: 'Leveraged staking',
                text: 'Get maximum attention for your token by placing it among the top 20 in our rankings on the “Buy” & “Stake” screens.\n'
            }
        ],
    }
}

export const featureContent = {
    feature: [
        {
            h1: "Integrate your token for less.",
            h2: "",
            h3: "No integration fees. Changex requires a small investment of 2000 USD worth of CHANGE tokens. The CHANGE will then be automatically staked and vested for a period of 45 days. Once the vesting period is over partners can redeem their tokens with a hefty reward for their staking.",
            h4: "",
            route: false,
            buttonTxt: "Read Whitepaper",
            buttonUrl: "https://whitepaper.changex.io/",
            buttonClass: "button-blue",
            imageUrl: "/assets/images/partners/integrate-illustration.svg",
            imageClass: "centerImage",
            alignImage: 'right',
            commingSoon: true,
            offerText: 'Unique offer until 31.03.2023',
            bottomText: 'Please note that the special promo will last until 31 March 2023 so make sure to get in touch and claim your spot in Changex.'
        }
    ],
    info: "Please note that the special promo will last until 31 March 2023 so make sure to get in touch and claim your spot in Changex."
}

export const becomeAPartner = {
    feature: [
        {
            h1: "Become our ",
            h2: "Partner",
            h3: "Let us know more about your company and we will get in touch in no time.",
            h4: "",
            buttonTxt: "",
            buttonUrl: "#",
            buttonClass: "",
            imageUrl: "/assets/images/partners/superhero-backgroundfull_1920-1311.png",
            imageClass: "",
            alignImage: 'right',
            commingSoon: false,
            offerText: '',
            bottomText: ''
        }
    ]
}

export const becomeAPartnerForm = {
    field1: " Company",
    field2: "Website",
    field3: "Email",
    field4: "Additional information",
    checkbox: "I agree to receive emails",
    buttonTxt: "Apply To Be A Partner",
    buttonClass: "background-color-off-white"
}
